import React, {Component} from 'react';
import Logger from "../helpers/Logger";
import Filters from "./Filters";

export default class FilterContainer extends Component {
    componentDidCatch(error, info) {
        const logger = new Logger(this.props.logPath);
        logger.critical('REACT: error caught in FilterContainer', error.toString());
    }

    render() {
        return (<Filters parameters={this.props.parameters} translations={this.props.translations} />);
    }
}

export const DOMAIN = 'filters';



// WEBPACK FOOTER //
// ./src/components/FilterContainer.js